import { render, staticRenderFns } from "./TabCompanies.vue?vue&type=template&id=62a002a5"
import script from "./TabCompanies.vue?vue&type=script&lang=js"
export * from "./TabCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports